var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c(
        "section",
        { staticClass: "bg-white py-8 border-b-2 border-gray-300" },
        [
          _c(
            "div",
            {
              staticClass:
                "w-full md:w-10/12 mx-auto flex flex-wrap px-4 md:px-0"
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "flex w-full md:w-2/3 lg:w-1/2 flex-col justify-center items-start"
                },
                [
                  _c("h2", { staticClass: "font-bold text-2xl" }, [
                    _vm._v("Login")
                  ]),
                  _c("h3", { staticClass: "text-xl text-gray-600 mr-5 mt-5" }, [
                    _vm._v("You will now be directed to the login page.")
                  ])
                ]
              )
            ]
          )
        ]
      )
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }